module.exports = __webpack_public_path__ + "img/tenge-sign.d4d73c90.svg";